// libs
import { connect } from 'react-redux';

// components
import Multitag from './Multitag';

// selectors
import { getTagTitles } from 'shared/store/details/selectors';

const mapStateToProps = (state: any) => ({
  productTags: getTagTitles(state),
});

export default connect(mapStateToProps)(Multitag);
